export default function iso8601ToDate(isoString) {
    if (!isoString) return null;
    return isoString.split("T")[0];
}